import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { ProfileState } from "@/components/ProfileSideDrawer/redux/types";

const selectProfile = (state: RootState): ProfileState => state?.profile;

export default createDraftSafeSelector(selectProfile, (profile: ProfileState): any => profile?.isProfileOpen);
